import * as React from 'react';

import { ImageProps } from 'components/atoms/Image/Image';
import PoolTeaser from 'components/organisms/Pool/elements/PoolTeaser';
import { POOL_TYPE } from 'defs/pools';
import i18n from 'helper/i18n';
import kcal from 'helper/kcal';
import { ContentTypePoolWorkoutDtoType } from 'types/services/magnolia/dtos/ContentTypePoolWorkoutDto';
import { RenderPoolItemsAdditionalProps } from './index';
import { getItemURL } from './utils';

const calculateCalories = (calories: number, kg: number): string => {
	const result = calories * kg;
	if (isNaN(result)) {
		return '0';
	}

	return kcal(Math.round(result));
};

type WorkoutPropsType = {
	items: ContentTypePoolWorkoutDtoType[];
	custom: RenderPoolItemsAdditionalProps;
	type: string;
};

export const Workout = ({ type, items, custom }: WorkoutPropsType) => {
	return (
		<div className="container">
			<div className="row">
				<div className="col-xs-12">
					<div className="o-pool__teasers">
						{items.map((item: ContentTypePoolWorkoutDtoType) => {
							const duration = Math.round(item.duration / 60);

							return (
								<PoolTeaser
									key={item.externalId}
									tag={i18n(
										`react.impulsCoach.components.poolTeaser.workout.tag.${item.trainingGoal ||
											'UNDEFINED'}`
									)}
									modifier={type}
									headline={item.title}
									intensity={item.intensity}
									image={(item.previewImage as ImageProps) || (item.fallbackImage as ImageProps)}
									link={getItemURL(item.externalId, POOL_TYPE.WORKOUT)}
									infos={[
										{
											value: calculateCalories(item.calories, custom.weight || 0) as string,
											unit: i18n('react.impulsCoach.views.pools.units.calories'),
										},
										{
											value: `${duration}`,
											unit: i18n('react.impulsCoach.views.pools.units.duration'),
										},
									]}
								/>
							);
						})}
					</div>
				</div>
			</div>
		</div>
	);
};
